<template>
  <q-card>
    <q-toolbar class="text-grey-6 q-py-none">
      <q-toolbar-title class="text-body2 text-weight-medium">{{ $t('main_campaigns') }} </q-toolbar-title>
    </q-toolbar>
    <q-separator />
    <q-tabs v-model="tab" class="text-grey" dense active-color="primary" indicator-color="primary" align="left">
      <q-tab name="campaignsConvertMore" icon="mdi-trending-up">
        <q-tooltip
          content-class="bg-secondary text-white"
          content-style="font-size: 12px"
          anchor="top middle"
          self="bottom middle"
          :offset="[-10, 0]"
        >
          {{ $t('convert_more') }}
        </q-tooltip>
      </q-tab>
      <q-tab name="campaignsCommissionHigher" icon="mdi-currency-usd">
        <q-tooltip
          content-class="bg-secondary text-white"
          content-style="font-size: 12px"
          anchor="top middle"
          self="bottom middle"
          :offset="[-10, 0]"
        >
          {{ $t('higher_commission') }}
        </q-tooltip>
      </q-tab>
    </q-tabs>
    <q-separator />
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="campaignsConvertMore" class="q-pa-none">
        <q-table
          class="q-pb-sm text-weight-bold text-primary"
          dense
          flat
          virtual-scroll
          table-header-class="text-grey"
          title-class="text-body1 text-bold"
          :rows-per-page-options="[0]"
          :columns="columnsConvertMore"
          :data="data.data.convertMore"
          hide-pagination
          hide-no-data
          row-key="id"
          hide-header
        >
        </q-table>
      </q-tab-panel>
      <q-tab-panel name="campaignsCommissionHigher" class="q-pa-none">
        <q-table
          class="q-pb-sm text-weight-bold text-primary"
          dense
          flat
          virtual-scroll
          table-header-class="text-grey"
          title-class="text-body1 text-bold"
          :rows-per-page-options="[0]"
          :columns="columnsCommissionHigher"
          :data="data.data.higherCommission"
          hide-pagination
          hide-no-data
          row-key="id"
          hide-header
        >
        </q-table>
      </q-tab-panel>
    </q-tab-panels>
  </q-card>
</template>

<script>
export default {
  name: 'ListCampaignsMain',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      tab: 'campaignsConvertMore',
      columnsConvertMore: [
        {
          name: 'campaign_name',
          label: 'Campanhas',
          field: 'campaign_name',
          align: 'left'
        }
      ],
      columnsCommissionHigher: [
        {
          name: 'name',
          label: 'Campanhas',
          field: 'name',
          align: 'left'
        },
        {
          name: 'value',
          label: 'Valor',
          field: 'value',
          align: 'right',
          format: (val, row) => {
            if (row.format === 'value') {
              return `R$ ${parseFloat(val).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`;
            }
            return `${val}%`;
          }
        }
      ]
    };
  }
};
</script>
